import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiUrl from "../../../Environment/Api";

function Add_TaskManagement() {
  const navigate = useNavigate();

  // today date
  const today = new Date().toISOString().split("T")[0];

  // Modal state
  const [clientData, setClientData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalInputValue, setModalInputValue] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [pendingIndex, setPendingIndex] = useState(null);
  const [notes, setNotes] = useState("");

  const UserName = localStorage.getItem("name");
  const UserId = localStorage.getItem("editor_id");
  const UserRole = localStorage.getItem("role");

  // Dynamic columns - Start with EMPTY array
  const [columns, setColumns] = useState([
    "Standard",
    "Premier",
    "Twilight",
    "DTD",
    "VRA",
    "VR",
  ]);
  const MAX_COLUMNS = 10;

  const defaultColumnNames = [
    "Standard",
    "Premier",
    "Twilight",
    "DTD",
    "VRA",
    "VR",
    "Col7",
    "Col8",
    "Col9",
    "Col10",
  ];

  // Table data
  const [tableData, setTableData] = useState([
    {
      id: 1,
      taskDate: today, // Fixed column
      address: "",
      clientAddress: "",
      countrycode: "",
    },
  ]);

  // Handle Add Row
  const handleAddRow = () => {
    const newRow = {
      id: Date.now(),
      taskDate: today,
      address: "",
      clientId: "",
    };
    // Add empty values for all dynamic columns
    columns.forEach((col, index) => {
      newRow[`col_${index}`] = "";
    });

    setTableData([...tableData, newRow]);
  };

  // Handle Input Change for ALL columns
  const handleInputChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    setTableData(updatedData);
  };

  // Handle Delete Row
  const handleDeleteRow = (id) => {
    setTableData(tableData.filter((row) => row.id !== id));
  };

  // Handle Clear All
  const handleClearAll = () => {
    setTableData([
      {
        id: 1,
        taskDate: today,
        address: "",
      },
    ]);
    // toast.info("All tasks cleared", { autoClose: 2000 });
  };

  // get client data
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientdetails`);
      setClientData(response.data || []);
      console.log("Client Data :", response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Modal Functions
  const openAddColumnModal = () => {
    const nextIndex = columns.length;
    setModalTitle("Add New Column");
    setModalInputValue(defaultColumnNames[nextIndex] || "");
    setIsEditMode(false);
    setPendingIndex(null);
    setShowModal(true);
  };

  const openEditColumnModal = (index) => {
    setModalTitle("Edit Column Name");
    setModalInputValue(columns[index]);
    setIsEditMode(true);
    setPendingIndex(index);
    setShowModal(true);
  };

  const handleModalSave = () => {
    if (!isEditMode && columns.length >= MAX_COLUMNS) {
      toast.error("Maximum 10 columns allowed");
      return;
    }

    if (isEditMode && pendingIndex !== null) {
      // EDIT column name
      const updatedColumns = [...columns];
      updatedColumns[pendingIndex] =
        modalInputValue || defaultColumnNames[pendingIndex];
      setColumns(updatedColumns);
    } else {
      // ADD column with default name
      const newIndex = columns.length;

      const newColumnName = modalInputValue || defaultColumnNames[newIndex];

      setColumns([...columns, newColumnName]);

      setTableData((prevData) =>
        prevData.map((row) => ({
          ...row,
          [`col_${newIndex}`]: "",
        })),
      );
    }

    setShowModal(false);
    setModalInputValue("");
    setPendingIndex(null);
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setModalInputValue("");
    setPendingIndex(null);
  };

  const handleRemoveColumn = (index) => {
    const updatedColumns = columns.filter((_, i) => i !== index);
    setColumns(updatedColumns);

    setTableData((prevData) =>
      prevData.map((row) => {
        const newRow = {};

        updatedColumns.forEach((_, i) => {
          newRow[`col_${i}`] = row[`col_${i >= index ? i + 1 : i}`] || "";
        });

        return {
          ...row,
          ...newRow,
        };
      }),
    );
  };

  const handleBack = () => {
    navigate(-1);
  };

  // handlesave
  const handleSave = async () => {
    try {
      const clientDetails = tableData.map((row) => {
        let clientInfo = clientData.find((c) => c.client_id === row.clientId);

        let obj = {
          client_id: row.clientId || "",
          client_name: clientInfo?.clientName || "",
          client_address: row.clientAddress || "",
          countrycode: row.countrycode || clientInfo?.countrycode || "",
          address: row.address || "",
          date: row.taskDate,
        };

        columns.forEach((col, index) => {
          obj[col.toLowerCase()] = row[`col_${index}`] || 0;
        });

        return obj;
      });

      const payload = {
        editor_id: UserId === "undefined" ? "admin" : UserId,
        editor_name: UserName,
        date: new Date().toISOString().split("T")[0],
        notes: notes,
        client_details: clientDetails,
      };

      console.log("POST DATA:", payload);

      await axios.post(`${apiUrl}/taskmanagement`, payload);

      toast.success("Task Saved Successfully!");

      // optional reset
      handleClearAll();
      setNotes("");

      navigate("/task-management");
    } catch (error) {
      console.error(error);
      toast.error("Failed to save task");
    }
  };

  return (
    <>
      <ToastContainer />

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{modalTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCancel}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Column Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalInputValue}
                  onChange={(e) => setModalInputValue(e.target.value)}
                  placeholder="Enter column name"
                  autoFocus
                  onKeyPress={(e) => e.key === "Enter" && handleModalSave()}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {UserRole === "editor" ? (
        <div className="d-flex justify-content-between">
          <div>
            <h3 className="text-center">Task Management</h3>
          </div>
          <div className="d-flex flex-column">
            <div>
              <span>Name :</span>
              <span className="ms-2">{UserName}</span>
            </div>

            <div>
              <span>ID :</span>
              <span className="ms-2">{UserId}</span>
            </div>
          </div>
        </div>
      ) : (
        <h3 className="text-center">Task Management</h3>
      )}
      <hr />

      <div>
        {/* <div className="bg-white p-3 rounded-3">
          <form className="row">
            <div className="col-lg-4 col-md-4">
              <label className="form-label">Client ID</label>
              <select className="form-select">
                <option value="">-- select Client --</option>
                {clientData.map((data, id) => (
                  <option key={id} value={data.client_id}>
                    {data.client_id} - {data.clientName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="form-label">Client Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Client Name"
              />
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="form-label">Date</label>
              <input type="date" className="form-control" />
            </div>
          </form>
        </div> */}

        <div className="bg-white p-3 rounded-3 mt-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Tasks</h5>
            <div>
              <button
                type="button"
                className="btn btn-success btn-sm me-2"
                onClick={handleAddRow}
              >
                <i className="fa-solid fa-plus me-1"></i> Add Task
              </button>
              {columns.length < MAX_COLUMNS && (
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={openAddColumnModal}
                >
                  <i className="fa-solid fa-plus me-1"></i> Add Column
                </button>
              )}
            </div>
          </div>

          {/* Table */}
          <div style={{ width: "100%", overflowX: "auto" }}>
            <table
              className="table table-bordered"
              style={{
                minWidth: "1200px",
                tableLayout: "fixed",
                borderCollapse: "collapse",
              }}
            >
              <thead className="font-size">
                <tr>
                  <th style={{ width: "30px" }}>No</th>
                  <th style={{ width: "145px" }}>Client ID / Name</th>
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "130px", display: "none" }}>
                    Client Address
                  </th>
                  <th style={{ width: "130px" }}>Address</th>

                  {/* Dynamic Columns */}
                  {columns.map((col, index) => (
                    <th key={index} style={{ width: "70px" }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditColumnModal(index)}
                        >
                          {col}
                        </span>
                        <div>
                          <i
                            className="fa-solid fa-edit me-2"
                            style={{ cursor: "pointer", fontSize: "13px" }}
                            onClick={() => openEditColumnModal(index)}
                            title="Edit"
                          ></i>
                          <i
                            className="fa-solid fa-trash text-danger"
                            style={{ cursor: "pointer", fontSize: "13px" }}
                            onClick={() => handleRemoveColumn(index)}
                            title="Remove"
                          ></i>
                        </div>
                      </div>
                    </th>
                  ))}
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={row.id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <select
                        className="form-select"
                        value={row.clientId || ""}
                        onChange={(e) => {
                          const selectedId = e.target.value;

                          const selectedClient = clientData.find(
                            (c) => c.client_id === selectedId,
                          );

                          const updatedData = [...tableData];

                          updatedData[index].clientId = selectedId;
                          // updatedData[index].address =
                          //   selectedClient?.address || "";

                          updatedData[index].clientAddress =
                            selectedClient?.address || "";

                          updatedData[index].countrycode =
                            selectedClient?.countrycode || "";

                          if (index === tableData.length - 1 && selectedId) {
                            const newRow = {
                              id: Date.now(),
                              taskDate: today,
                              address: "",
                              clientId: "",
                            };

                            columns.forEach((_, i) => {
                              newRow[`col_${i}`] = "";
                            });

                            updatedData.push(newRow);
                          }

                          setTableData(updatedData);
                        }}
                      >
                        <option value="">-- Select Client --</option>
                        {clientData.map((data, id) => (
                          <option key={id} value={data.client_id}>
                            {data.client_id} - {data.alternat_name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        // style={{
                        //   width: "140px",
                        //   height: "35px",
                        // }}
                        value={row.taskDate || today}
                        onChange={(e) =>
                          handleInputChange(index, "taskDate", e.target.value)
                        }
                      />
                    </td>
                    <td style={{ display: "none" }}>
                      <input
                        style={{ width: "100%" }}
                        className="form-control"
                        type="text"
                        value={row.clientAddress}
                        readOnly
                      />
                    </td>
                    <td style={{ display: "none" }}>
                      <input
                        style={{ width: "100%" }}
                        className="form-control"
                        type="text"
                        value={row.countrycode}
                        readOnly
                      />
                    </td>

                    <td>
                      <input
                        style={{ width: "100%" }}
                        className="form-control"
                        type="text"
                        value={row.address || ""}
                        onChange={(e) =>
                          handleInputChange(index, "address", e.target.value)
                        }
                        placeholder="Enter address"
                      />
                    </td>

                    {/* Dynamic Columns Inputs */}
                    {columns.map((col, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="form-control"
                          value={row[`col_${colIndex}`] || ""}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              `col_${colIndex}`,
                              e.target.value,
                            )
                          }
                        />
                      </td>
                    ))}

                    <td>
                      <button
                        className="btn btn-danger px-2 py-1"
                        onClick={() => handleDeleteRow(row.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Notes Section */}
          <div className="row mt-4">
            <div className="col-lg-6">
              <label className="form-label">
                <b>Notes / Remarks :</b>
              </label>
              <textarea
                className="form-control notes-textarea"
                rows="4"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Add any notes here..."
              ></textarea>
            </div>
          </div>

          {/* Bottom Buttons */}

          <div className="d-flex justify-content-end align-items-center my-3">
            <div
              style={{ marginLeft: "75px" }}
              className="d-flex gap-3 justify-content-evenly mt-3 buttonstyle"
            >
              <button
                type="button"
                className="btn btn-danger invoice-button"
                onClick={handleClearAll}
              >
                Clear
              </button>
              <button
                type="button"
                className="btn btn-info text-white invoice-button"
                style={{ backgroundColor: "#007BFF" }}
                onClick={handleBack}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-success invoice-button"
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add_TaskManagement;
